import type {ImageProps as MantineImageProps} from '@mantine/core';
import {Image as MantineImage} from '@mantine/core';

export type ImageProps = MantineImageProps;

/**
 * Image with fit/radius/fallback — design-layer pass-through over Mantine `Image`.
 * @registry Pass-through Mantine Image; import this instead of @mantine/core outside src/design.
 */
export const Image = MantineImage;
